import { render, staticRenderFns } from "./Zona.vue?vue&type=template&id=5309ff98&scoped=true"
import script from "./Zona.vue?vue&type=script&lang=js"
export * from "./Zona.vue?vue&type=script&lang=js"
import style0 from "./Zona.vue?vue&type=style&index=0&id=5309ff98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309ff98",
  null
  
)

export default component.exports